import {
  ALERT,
} from "./types";

import PostsService from "@/services/posts-service";

export const like = (postId: number, newState: boolean) => (dispatch: (any:any) => void) => {
  return PostsService.likePost(postId, newState).then(
    (res) => {
      return Promise.resolve(res.data);
    },
    (error: {response?: {data?: {message?: string}}, message?: string}) => {
      const resData = (error.response && error.response.data) || false;
      const message =
        (resData &&
          error.response?.data?.message) ||
        error.message ||
        error.toString();

      dispatch({
        type: ALERT,
        payload: { message: resData || { result: 0, message } },
      });

      return Promise.reject();
    }
  );
};
